export const formatMoney = (value) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(value);
    };

// Format brut pour l'input (ex: 12 345,67)
export const formatMoneyInput = (value) => {
    if (value === '' || value === null || isNaN(value)) return '';
    return Number(value).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

